module.exports = __webpack_public_path__ + "img/jo.8d8270c8.svg";